export const ADD_PERSON = "addPerson";
export const ADD_PERSON_PENDING = "addPerson/pending";
export const ADD_PERSON_REJECTED = "addPerson/rejected";
export const ADD_PERSON_FULFILLED = "addPerson/fulfilled";
